<template>
  <div class="home-page">
    <div
      class="home-page-main"
      :style="{
        backgroundImage: `url(${backgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '80% 70%',
        backgroundSize: 'cover',
      }"
    >
      <Header />
      <div class="container-main">
        <div class="swiper-content-left swiper-fixed">
          <div class="swiper-content-left-title">{{ list?.[0]?.title }}</div>
          <div class="swiper-content-left-tips">{{ list?.[0]?.tips }}</div>
          <div class="swiper-content-left-btn">了解更多</div>
        </div>
        <!-- 添加轮播图组件 -->
        <swiper :options="swiperOptions">
          <swiperSlide v-for="(item, index) in list" :key="index">
            <div class="swiper-content">
              <div class="swiper-content-left">
                <!-- <div class="swiper-content-left-title">{{ item.title }}</div>
                <div class="swiper-content-left-tips">{{ item.tips }}</div>
                <div class="swiper-content-left-btn">了解更多</div> -->
              </div>
              <div class="swiper-content-right">
                <div class="swiper-content-right-title">
                  {{ item.productTitle }}
                </div>
                <div class="swiper-content-right-tips">
                  {{ item.productDesc }}
                </div>
              </div>
            </div>
          </swiperSlide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Header from "./components/header.vue";
import Footer from "./components/footer.vue";

// 使用 import 导入图片资源，确保构建时能正确处理
import home0 from "@/assets/img/home0.png";
import home1 from "@/assets/img/home1.png";
import home2 from "@/assets/img/home2.png";
import home3 from "@/assets/img/home3.png";

const currentIndex = ref(0);

// 计算背景图片
const backgroundImage = computed(() => {
  const images = [home0, home1, home2, home3];
  return images[currentIndex.value] || images[0];
});

const list = [
  {
    title: "如鉴黄金只为你",
    tips: "如鉴黄金是专注于实物贵金属高效流通的现代化服务品牌。以科技赋能传统回收行业，为贵金属消费者、贵金属从业者打造专业、快速的的贵金属鉴定体验，让闲置贵金属焕发新生价值。",
    productTitle: "产品一",
    productDesc: "没有什么比我们自己的奢侈珠宝更能为您的整体增添魅力的了；",
  },
  {
    title: "如鉴黄金只为你",
    tips: "如鉴黄金是专注于实物贵金属高效流通的现代化服务品牌。以科技赋能传统回收行业，为贵金属消费者、贵金属从业者打造专业、快速的的贵金属鉴定体验，让闲置贵金属焕发新生价值。",
    productTitle: "产品二",
    productDesc: "没有什么比我们自己的奢侈珠宝更能为您的整体增添魅力的了；",
  },
  {
    title: "如鉴黄金只为你",
    tips: "如鉴黄金是专注于实物贵金属高效流通的现代化服务品牌。以科技赋能传统回收行业，为贵金属消费者、贵金属从业者打造专业、快速的的贵金属鉴定体验，让闲置贵金属焕发新生价值。",
    productTitle: "产品三",
    productDesc: "没有什么比我们自己的奢侈珠宝更能为您的整体增添魅力的了；",
  },
  {
    title: "如鉴黄金只为你",
    tips: "如鉴黄金是专注于实物贵金属高效流通的现代化服务品牌。以科技赋能传统回收行业，为贵金属消费者、贵金属从业者打造专业、快速的的贵金属鉴定体验，让闲置贵金属焕发新生价值。",
    productTitle: "产品四",
    productDesc: "没有什么比我们自己的奢侈珠宝更能为您的整体增添魅力的了；",
  },
];

const swiperOptions = ref({
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 10000, // 10秒切换
    disableOnInteraction: false,
    enabled: true, // 确保自动播放启用
  },
  loop: true,
  on: {
    slideChange: function () {
      currentIndex.value = this.realIndex;
    },
  },
});
</script>

<style lang="less" scoped>
.home-page {
  .home-page-main {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 204px);
    overflow: auto;
    background-size: 100% 100%;
    transition: all 0.3s;

    .container-main {
      flex: 1;
      overflow: auto;

      .swiper-container {
        width: 100%;
        height: 100%;

        .swiper-content {
          width: 75%;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;

          .swiper-content-right {
            max-width: 294px;

            .swiper-content-right-title {
              font-family: Microsoft YaHei;
              font-weight: 400;
              font-size: 18px;
              color: #2e425c;
              padding-bottom: 14px;
              box-sizing: border-box;
            }

            .swiper-content-right-tips {
              font-family: Microsoft YaHei;
              font-weight: 400;
              font-size: 14px;
              color: #2e425c;
              line-height: 26px;
              opacity: 0.8;
            }
          }
        }
      }
      .swiper-fixed {
        position: absolute;
        left: 12%;
        z-index: 2;
      }
      .swiper-content-left {
        padding-top: 125px;
        max-width: 510px;
        box-sizing: border-box;

        .swiper-content-left-title {
          font-family: SourceHanSansCN;
          font-weight: 300;
          font-size: 48px;
          color: #2e425c;
        }

        .swiper-content-left-tips {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 15px;
          color: #2e425c;
          opacity: 0.8;
          padding: 30px 0 70px 0;
          box-sizing: border-box;
        }

        .swiper-content-left-btn {
          cursor: pointer;
          display: inline-block;
          background: #31415a;
          border-radius: 31px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
          padding: 25px 60px;
          box-sizing: border-box;
        }
      }
      .swiper-pagination {
        bottom: 60px !important;
        right: 13% !important;
        left: auto;
        display: flex;
        justify-content: end;
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .home-page {
    .home-page-main {
      height: calc(100vh - 100px) !important;
      position: relative;
      .swiper-content {
        width: 90% !important;
      }
      .swiper-fixed {
        left: 4% !important;
        // bottom: 0 !important;
      }
      .swiper-content-left {
        max-width: 80% !important;
        .swiper-content-left-title {
          font-size: 22px !important;
        }

        .swiper-content-left-tips {
          font-size: 12px !important;
        }

        .swiper-content-left-btn {
          font-size: 12px !important;
          padding: 4px 10px !important;
        }
      }
    }
  }
}
</style>
